import { createFileRoute } from '@tanstack/react-router';
import { InscriptionGate } from '@/features/subscription/shared/InscriptionGate';
import InscriptionFormPage from '@/features/subscription/inscription-form-page/InscriptionFormPage';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/$jobId_/inscricao/formulario')({
  component: () => (
    <InscriptionGate>
      <InscriptionFormPage />
    </InscriptionGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
